export enum SourceDestEnum {
    Unknown = -1,
    Customer = 0,
    CIT = 1,
    CashDesk = 2,
    CentralFund = 3,
    ATMs = 4,
    NotCertifiedCIT = 5,
    NotCertifiedCashDesk = 6,
    NotCertifiedCentralFund = 7,
}

export function getSourceDestEnumLabel(value: SourceDestEnum): string {
    switch (value) {
        case SourceDestEnum.Customer:
            return "enum.sourceDest.Customer";
        case SourceDestEnum.CIT:
            return "enum.sourceDest.CIT";
        case SourceDestEnum.CashDesk:
            return "enum.sourceDest.CashDesk";
        case SourceDestEnum.CentralFund:
            return "enum.sourceDest.CentralFund";
        case SourceDestEnum.ATMs:
            return "enum.sourceDest.ATMs";
        case SourceDestEnum.NotCertifiedCIT:
            return "enum.sourceDest.NotCertifiedCIT";
        case SourceDestEnum.NotCertifiedCashDesk:
            return "enum.sourceDest.NotCertifiedCashDesk";
        case SourceDestEnum.NotCertifiedCentralFund:
            return "enum.sourceDest.NotCertifiedCentralFund";
        default:
            return "common.unknown";
    }
}
